import { render, staticRenderFns } from "./ObjectMenu.vue?vue&type=template&id=45609ef6&scoped=true"
import script from "./ObjectMenu.vue?vue&type=script&lang=ts"
export * from "./ObjectMenu.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45609ef6",
  null
  
)

export default component.exports